'use strict';

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(($) => {

	const $B = mpro.get$B();
	const $W = mpro.get$W();
	const arrSelector = mpro.config.ui.scroll_top_arrow_selector;

	const $arrTop = $(arrSelector);
	let isRunning = false;

	$B.on('click', arrSelector, function (e) {
		e.preventDefault();
		isRunning = true;
		mpro.scrollToPos(0, 0, { speed: 466 }).promise().done(() => {
			isRunning = false;
		});
		$arrTop.fadeOut('fast');
	});

	const toggleArrow = () => {
		if ($arrTop.length && !isRunning) {
			if ($W.scrollTop() >= 600) {
				$arrTop.fadeIn('fast');
			}
			else {
				$arrTop.fadeOut('fast');
			}
		}
	};

	// Add passive listener
	window.addEventListener('scroll', toggleArrow, { passive: true });
	toggleArrow();
});
